import { toRaw } from 'vue'
import { toLower, camelCase } from 'lodash'

export function groupByKey(items, key) {
	let values = {}

	for (const item of items) {
		if (!item) {
			continue
		}
		if (item[key] !== null) {
			values[item[key]] = values[item[key]] || []
			values[item[key]].push(item)
		}
	}

	return values
}

export function isEmptyObject(v) {
	if (v == null) return true
	if (typeof v !== 'object') return true
	for (const p in v) {
		if (Object.hasOwn(v, p)) return false
	}
	return true
}

export const toNumber = (num) => Number(String(num).replace(/[^0-9.-]/g, ''))
export const isNumber = (val) => val != null && !isNaN(String(val).replace(/[^0-9.-]/g, '')) ? Number(val) : val
export const toZero = (num) => Math.abs(num) <= Number.EPSILON ? 0 : num
export const stripHTML = (str) => {
	const doc = new DOMParser().parseFromString(str, 'text/html')
	return doc.body.textContent || ''
}
export const isNotZero = (v) => {
	return v == null || v == undefined || v == ''
}

export const toSectionId = (str) => str.replace(/[^a-zA-Z0-9]/g, '')

export const numberNames = [
	"Zero", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine",
	"Ten", "Eleven", "Twelve", "Thirteen", "Fourteen", "Fifteen", "Sixteen", "Seventeen",
	"Eighteen", "Nineteen",
	"Twenty", "Twenty-One", "Twenty-Two", "Twenty-Three", "Twenty-Four", "Twenty-Five", "Twenty-Six", "Twenty-Seven", "Twenty-Eight", "Twenty-Nine"
]

export const unproxy = (data) => JSON.parse(JSON.stringify(toRaw(data)))


export const isNull = (v) => {
	return v === null || v === undefined
}

export const isEmptyString = (v) => {
	return v === ''
}

export const isNotEmpty = (v) => {
	return v !== null && v !== undefined && v.trim?.() !== '';
  }

export const convertNumberName = (num) => {
	if (num === 0) return "Zero"; // Capitalize "Zero"

	const ones = [
	  "",
	  "One",
	  "Two",
	  "Three",
	  "Four",
	  "Five",
	  "Six",
	  "Seven",
	  "Eight",
	  "Nine",
	  "Ten",
	  "Eleven",
	  "Twelve",
	  "Thirteen",
	  "Fourteen",
	  "Fifteen",
	  "Sixteen",
	  "Seventeen",
	  "Eighteen",
	  "Nineteen",
	];
	const tens = [
	  "",
	  "",
	  "Twenty",
	  "Thirty",
	  "Forty",
	  "Fifty",
	  "Sixty",
	  "Seventy",
	  "Eighty",
	  "Ninety",
	];
	const scales = ["", "Thousand", "Million", "Billion", "Trillion"];  
   // Capitalize scale words

	function convertChunk(chunk) {
	  let words = "";
	  if (chunk >= 100) {
		words += ones[Math.floor(chunk / 100)] + " Hundred"; // Capitalize "Hundred"
		chunk %= 100;
		if (chunk > 0) words += " ";
	  }
	  if (chunk >= 20) {
		words += tens[Math.floor(chunk / 10)] + " ";
		chunk %= 10;
	  }
	  if (chunk > 0) {
		words += ones[chunk];
	  }
	  return words;
	}

	let words = "";
	let scaleIndex = 0;
	while (num > 0) {
	  const chunk = num % 1000;
	  if (chunk > 0) {
		if (words.length > 0) words = " " + words;
		words = convertChunk(chunk) + " " + scales[scaleIndex] + words;
	  }
	  num = Math.floor(num / 1000);
	  scaleIndex++;
	}

	return words.trim();
}


export const arrayOverlap = (arr1, arr2) => {
	const set1 = new Set(arr1)
	for (const e of arr2) {
		if (set1.has(e)) return true
	}
	return false
}

export const convertToId = (val) => {
	return toLower(camelCase(toLower(val)))
}

export const encodeHTML = (str) => {
	const map = {
		'&': '&amp;',
		'<': '&lt;',
		'>': '&gt;',
		'"': '&quot;',
		"'": '&#039;'
	}

	return str.replace(/[&<>"']/g, (m) => (map[m]))
}

export const sectionListToArray = (guidelineId, sectionIds) => {
	return sectionIds.split(`,`).map(s => s.match(/-$/) ? toLower(camelCase(toLower(`${guidelineId}${s}`)))+'-' : toLower(camelCase(toLower(`${guidelineId}${s}`))))
}

export const parentSection = (sectionId) => {
	return String(sectionId)?.match(/(^\d)(\w)(\d+)/i)?.[0]
}

export const toPath = (...args) => {
	return args.filter(n => n).join(`/`)
}

export const logCount = () => {
	let groupCount = 1

	const originalLog = console.log

	console.log = function () {
		const args = Array.from(arguments)

		if (args && typeof args === 'string' && args.startsWith('Group:')) {
			originalLog.group('GROUP')
		} else if (args === 'GroupEnd') {
			groupCount = 1
			originalLog.groupEnd()
		} else {
			groupCount++
			// originalLog.log(groupCount, args)
			originalLog.apply(console, args)
		}
	}
}


export class Log {
	logCount = 0

	constructor(label) {
		this.logCount = 0
	}

	group(label) {
		console.group(label)
	}

	log() {
		this.logCount++
		const args = Array.from(arguments)

		const error = new Error()
		const stackTrace = error.stack.split('\n')
		const funcs = stackTrace.filter(f => f.match(/at (Proxy\.)(\w+) \((.*):(\d+):(\d+)\)/))
		const [func] = funcs
		const functionNameMatch = func.match(/at (Proxy\.)?(\w+) \((.*):(\d+):(\d+)\)/);
		const functionName = functionNameMatch ? functionNameMatch[2]: 'unknown function'
		const lineNumber = functionNameMatch? functionNameMatch[4]: 'unknown line'
		// console.log({ stackTrace, funcs, functionNameMatch, })
		console.log(`${functionName}.${lineNumber} `, ...args)
	}

	groupEnd() {
		console.groupEnd()
	}
}
